module.exports = __webpack_public_path__ + "static/media/Formular-Regular.7813bcc9.woff2";